import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { getItem, removeItem } from '../../utils/cache';
import axios from 'axios';
import Button from '../../ui-core/Button/Button';
import Login from './components/Login';
import SignUp from './components/SignUp';
import OtpModal from './components/OtpModal';
import WaitList from './components/WaitList';
import SuccessModal from './components/SuccessModal';
import Testimonial from './components/testimonial';
import Calender from './components/Calender';
import Card from './components/Card';
import Community from './components/Community';
import Display from './components/Display';
import Header from './components/Header';
import SeoTags from '../../components/SeoComponent';

import {
  SURVEY_STATUS,
  TEXT_CONSTANT,
  LOCAL_STORAGE_CONSTANT,
  MODAL_TYPE,
  // IMAGE_CONSTANT,
} from '../../constants/app';
import WhyJen from './components/WhyJen';
import Steps from './components/Steps';
import Offer from './components/Offer';
import Modal from './components/Modal';
import { getDisplayType, logOutput, scrollToTop } from '../../utils/helpers';
import useWindowWidth from '../../hooks/useWindowWidth';
import NeckPain from './components/NeckPain';
import { APP_ROUTES } from '../../route';
import {
  analyticsReset,
  SEGMENT_EVENTS,
  trackEvent,
} from '../../utils/Segment';
import { getCanonicalLink, SeoTexts } from '../../services/SEO';

import '../NewHome/style.css';
import PhoneModal from './components/PhoneModal/Index';
import AssessmentModal from './components/Assessment';
import ResetPasswordModal from './components/ResetPasswordModal';
import ResetPasswordOtpModal from './components/ResetPasswordModal/ResetPasswordOtpModal';
import ChangePasswordModal from './components/ResetPasswordModal/ResetPassword';
import EmailModal from './components/EmailModal';
import AddEmailModal from './components/EmailModal/AddEmailModal';
import ConfirmEmailModal from './components/EmailModal/ConfirmEmailModal';
import EmailOtpModal from './components/EmailModal/EmailOtpModal';
import ConfirmPhoneModal from './components/PhoneModal/ConfirmPhoneModal';
import { useCourseDetail } from '../../hooks/useCourseDetail';
import { extractJSON } from '../../services/jsonUtil';
import NameModal from './components/SignUp/NameModal';

export const Wrapper = props => {
  const displayType = getDisplayType(useWindowWidth());
  const isMobileScreen = displayType === 'mobile';
  if (!isMobileScreen) return props.children;

  // const text = {
  //   [MODAL_TYPE.SIGNUP]: {
  //     heading: 'SignUp',
  //     subHeading: 'Signup with your mobile number',
  //   },
  //   [MODAL_TYPE.LOGIN]: {
  //     heading: 'Login',
  //     subHeading: 'Login with your mobile number',
  //   },
  //   [MODAL_TYPE.OTP]: {
  //     heading: 'Enter Code',
  //     subHeading: 'Just one last step to verify your account with us',
  //   },
  // };

  return (
    // <div className="wrapper">
    //   <div className="wrapper-header position-relative">
    //     <div onClick={props.handleGoBack} className="go-back-block">
    //       <img src={IMAGE_CONSTANT.arrowLeft} alt="back" />
    //     </div>
    //     <h1>{text[props.type].heading}</h1>
    //     <p>{text[props.type].subHeading}</p>
    //   </div>
    <div className="wrapper-body">{props.children}</div>
    // </div>
  );
};

const NewHome = () => {
  const navigate = useNavigate();
  const [countryCode, setCountryCode] = useState('us');
  const [modalState, setModalState] = useState(null);
  const handleModalState = modalData => {
    setModalState(modalData);
  };
  const displayType = getDisplayType(useWindowWidth());
  const isMobileScreen = displayType === 'mobile';
  const CompaleteOnBoarding = localStorage?.getItem('completeOnboarding');
  const localMatch = getItem('localMatch');
  const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
  // const mergePhoneDetails = JSON.parse(getItem('mergePhoneDetail'));
  const { handleCourseRedirection } = useCourseDetail(localMatch);

  const handleModalEvent = modalType => {
    setModalState(modalType);
  };
  useEffect(() => {
    scrollToTop();
    if (
      getItem(LOCAL_STORAGE_CONSTANT.SURVEY_STATUS) === `${SURVEY_STATUS.DONE}`
    ) {
      setModalState(MODAL_TYPE.SUCCESS);
      analyticsReset();
    }
    removeItem(LOCAL_STORAGE_CONSTANT.SURVEY_SESSION);
    removeItem(LOCAL_STORAGE_CONSTANT.SURVEY_STATUS);
    axios
      .get('https://ipapi.co/json/')
      .then(response => {
        const data = response.data;
        setCountryCode(data.country_code.toLowerCase());
      })
      .catch(error => {
        logOutput(error);
      });
  }, []);

  useEffect(() => {
    if (CompaleteOnBoarding && !user) {
      handleModalState(MODAL_TYPE.SIGNUP);
    }
  }, []);

  const handleAuthFlow = (buttonTitle, eventType, section) => {
    handleModalEvent(eventType);
    trackEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
      button_title: buttonTitle,
      page: 'Home Page',
      section_title: `${section}`,
    });
    trackEvent(SEGMENT_EVENTS.AUTH_FLOW_INITIATED, {
      page: 'Home Page',
      section_title: `${section}`,
    });
    if (isMobileScreen) {
      scrollToTop();
    }
    // trackDisplayedEvent(`Display ${event} modal`, {
    //   page: 'Home Page',
    //   section_title: `${event} Modal`,
    // });

    // if (
    //   section?.toLowerCase() !== 'navigation header' ||
    //   !section?.toLowerCase()?.includes('header')
    // ) {
    //   // Set redirectUrl and Slug in local storage
    //   const urlParams = new URLSearchParams(location.search);
    //   const page = urlParams.get('page');
    //   const slug = params.slug || page;
    //   setItem('redirectToCourse', window.location.href);
    //   setItem('localMatch', JSON.stringify({ params }));
    //   setItem('localSlug', slug);
    //   // setLocalSlug(slug);
    //   // setItem('isFromCoursePage', true);
    // }
  };

  const redirectToPaymentPage = section => {
    trackEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
      button_title: TEXT_CONSTANT.GET_STARTED_FOR_FREE,
      page: 'Home Page',
      section_title: section,
    });
    navigate(APP_ROUTES.FREE_TRAIL);
  };

  const renderHomePage = () => (
    <React.Fragment>
      <Header onClick={handleAuthFlow} />
      <Display
        onClick={handleAuthFlow}
        redirectToPaymentPage={redirectToPaymentPage}
      />
      <Steps />
      <WhyJen
        onClick={() =>
          // handleAuthFlow('GET STARTED FOR FREE', 'isSignup', 'Why Jen ?')
          navigate(APP_ROUTES.SIGNUP_ONBOARDING)
        }
      />
      <Card />
      <Offer
        onClick={() =>
          handleAuthFlow(
            'GET STARTED FOR FREE',
            // 'isSignup',
            'isLogin',
            TEXT_CONSTANT.EXCERCISE_PLAN_MADE_FOR_YOU,
          )
        }
      />
      <Calender />
      <Community
        onClick={() =>
          handleAuthFlow(
            'JOIN NOW',
            'isLogin',
            'Be part of a community that supports you',
          )
        }
      />
      <NeckPain />
      <Testimonial />
      <footer className="bg-OysterBay text-center px-3 home-footer">
        <h3>{TEXT_CONSTANT.FOOTER_HEADER_TEXT}</h3>
        <p>{TEXT_CONSTANT.FOOTER_SUB_TEXT}</p>
        <Button
          onClick={() =>
            // handleAuthFlow(
            //   'GET STARTED FOR FREE',
            //   'isSignup',
            //   TEXT_CONSTANT.FOOTER_HEADER_TEXT,
            // )
            navigate(APP_ROUTES.SIGNUP_ONBOARDING)
          }
          text="GET STARTED FOR FREE"
          class="sign-up-button-white d-inline-block footer-btn"
          isDisabled={false}
        />
      </footer>
    </React.Fragment>
  );

  const renderModalContent = () => {
    switch (modalState) {
      case MODAL_TYPE.LOGIN:
        return (
          <Wrapper type={modalState} handleGoBack={() => setModalState(null)}>
            <Login
              countryCode={countryCode}
              handleModalState={handleModalState}
              handleModalEvent={handleModalEvent}
            />
          </Wrapper>
        );
      case MODAL_TYPE.OTP:
        return (
          <Wrapper type={modalState} handleGoBack={() => setModalState(null)}>
            <OtpModal
              handleModalState={handleModalState}
              handleModalEvent={handleModalEvent}
              handleClose={handleClose}
            />
          </Wrapper>
        );
      case MODAL_TYPE.SIGNUP:
        return (
          <Wrapper type={modalState} handleGoBack={() => setModalState(null)}>
            <SignUp
              countryCode={countryCode}
              handleModalState={handleModalState}
              handleModalEvent={handleModalEvent}
            />
          </Wrapper>
        );
      case MODAL_TYPE.PHONE:
        return (
          <Wrapper type={modalState} handleGoBack={() => setModalState(null)}>
            <PhoneModal
              countryCode={countryCode}
              handleModalState={handleModalState}
              handleModalEvent={handleModalEvent}
            />
          </Wrapper>
        );
      case MODAL_TYPE.ASSESSMENT:
        return (
          <Wrapper type={modalState} handleGoBack={() => setModalState(null)}>
            <AssessmentModal
              countryCode={countryCode}
              handleModalState={handleModalState}
              handleModalEvent={handleModalEvent}
              handleClose={handleClose}
            />
          </Wrapper>
        );
      case MODAL_TYPE.SUCCESS:
        return <SuccessModal />;
      case MODAL_TYPE.WAITLIST:
        return <WaitList />;
      case MODAL_TYPE.RESET_PASSWORD:
        return <ResetPasswordModal handleModalState={handleModalState} />;
      case MODAL_TYPE.RESET_OTP:
        return <ResetPasswordOtpModal handleModalState={handleModalState} />;
      case MODAL_TYPE.CONFIRM_PHONE_NUMBER:
        return <ConfirmPhoneModal handleModalState={handleModalState} />;
      case MODAL_TYPE.CHANGE_PASSWORD:
        return <ChangePasswordModal handleModalState={handleModalState} />;
      case MODAL_TYPE.EMAIL_LOGIN:
        return (
          <EmailModal
            handleModalState={handleModalState}
            handleClose={handleClose}
          />
        );
      case MODAL_TYPE.ADD_EMAIL:
        return <AddEmailModal handleModalState={handleModalState} />;
      case MODAL_TYPE.CONFIRM_EMAIL:
        return <ConfirmEmailModal handleModalState={handleModalState} />;
      case MODAL_TYPE.EMAIL_OTP:
        return (
          <EmailOtpModal
            handleModalState={handleModalState}
            handleClose={handleClose}
          />
        );
      case MODAL_TYPE.NAME:
        return <NameModal handleModalState={handleModalState} />;
      default:
        return null;
    }
  };

  const dialogClassName = (() => {
    switch (modalState) {
      case MODAL_TYPE.SUCCESS:
        return 'success-modal';
      case MODAL_TYPE.WAITLIST:
        return 'survey-modal';
      case MODAL_TYPE.NAME:
        return 'sign-onboarding-modal auth-modal my-0 py-4 modal-lg modal-dialog-centered';
      default:
        return undefined;
    }
  })();

  const handleClose = () => {
    const onboardingCompleted = extractJSON('completeOnboarding');
    const isRedirectCourse = getItem('redirectToCourse');
    const session = extractJSON(LOCAL_STORAGE_CONSTANT.SESSION);
    const localUser = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
    const isFromCoursePage = getItem('isFromCoursePage');
    const isFromLogin = getItem('isFromLogin');

    if (session && onboardingCompleted) {
      navigate(APP_ROUTES.ASSESSMENT_ONBOARDING);
    }
    // Commented due to issue JW-277
    if (onboardingCompleted && !user && modalState === MODAL_TYPE.SIGNUP) {
      removeItem('completeOnboarding');
    }
    if (modalState === MODAL_TYPE.PHONE && !isRedirectCourse) {
      removeItem(LOCAL_STORAGE_CONSTANT.SURVEY_SESSION);
      removeItem(LOCAL_STORAGE_CONSTANT.SURVEY_STATUS);
      setModalState(false);
      navigate(APP_ROUTES?.HOME);
    }
    if (
      // modalState === MODAL_TYPE.PHONE ||
      modalState === MODAL_TYPE.OTP ||
      modalState === MODAL_TYPE.ADD_EMAIL ||
      modalState === MODAL_TYPE.EMAIL_OTP ||
      modalState === MODAL_TYPE.ASSESSMENT // Added for JW-243
    ) {
      removeItem(LOCAL_STORAGE_CONSTANT.SURVEY_SESSION);
      removeItem(LOCAL_STORAGE_CONSTANT.SURVEY_STATUS);
      setModalState(false);
      // removeItem('completeOnboarding'); // commented for testing purpose
      navigate(APP_ROUTES?.HOME);
    } else {
      removeItem(LOCAL_STORAGE_CONSTANT.SURVEY_SESSION);
      removeItem(LOCAL_STORAGE_CONSTANT.SURVEY_STATUS);
      setModalState(false);
      // removeItem('completeOnboarding'); // commented for testing purpose
    }
    if (modalState === MODAL_TYPE.LOGIN || modalState === MODAL_TYPE.SIGNUP) {
      removeItem('isOfflineCheckout');
    }
    // if (!isRedirectCourse && (modalState === MODAL_TYPE.OTP && mergePhoneDetails)) {
    //   navigate(APP_ROUTES.HOME);
    // }

    if (session) {
      if (isRedirectCourse || isFromCoursePage) {
        if (localUser?.attributes?.new_user && isFromLogin === 'false') {
          handleModalState(MODAL_TYPE.NAME);
          // removeItem('isFromLogin');
        } else {
          if (
            modalState !== MODAL_TYPE.LOGIN &&
            modalState !== MODAL_TYPE.SIGNUP &&
            !(
              modalState === 'isEmailLogin' &&
              localUser?.attributes?.mobile === ''
            )
          ) {
            handleCourseRedirection();
            removeItem('redirectToCourse');
            removeItem('localMatch');
            removeItem('localSlug');
          }
        }
      }
    }
    removeItem('redirectToCourse');
    removeItem('localMatch');
    removeItem('localSlug');
    // removeItem('isFromCoursePage');
  };

  const renderContentMobile = () => {
    if (modalState) {
      return renderModalContent();
    } else {
      return renderHomePage();
    }
  };

  return (
    <div className={clsx('main', isMobileScreen && modalState && 'h-100')}>
      {isMobileScreen &&
      ![
        MODAL_TYPE.SUCCESS,
        MODAL_TYPE.WAITLIST,
        MODAL_TYPE.SIGNUP,
        MODAL_TYPE.PHONE,
        MODAL_TYPE.OTP,
      ].includes(modalState)
        ? renderContentMobile()
        : renderHomePage()}
      {isMobileScreen &&
        [MODAL_TYPE.SUCCESS, MODAL_TYPE.WAITLIST].includes(modalState) && (
          <Modal
            dialogClassName={dialogClassName}
            show={Boolean(modalState)}
            handleClose={handleClose}
          >
            {renderModalContent()}
          </Modal>
        )}
      {
        // !isMobileScreen && (
        <Modal
          dialogClassName={dialogClassName}
          show={Boolean(modalState)}
          handleClose={handleClose}
        >
          {renderModalContent()}
        </Modal>
        // )
      }
      <SeoTags
        title={SeoTexts.JEN_WEB_TITLE}
        metaDescription={SeoTexts.JEN_WEB_DESCRIPTION}
        canonicalLink={getCanonicalLink()}
        ogImgUrl={SeoTexts.JEN_WEB_OG_IMAGE_URL}
        twitterImgUrl={SeoTexts.JEN_WEB_TWITTER_IMAGE_URL}
      />
    </div>
  );
};

Wrapper.propTypes = {
  children: PropTypes.node,
  type: PropTypes.string,
  handleGoBack: PropTypes.func,
};

NewHome.propTypes = {};

export default NewHome;
